import { GetEmailTemplatesMeta, GetEmailTemplatesPayload } from 'types/store/GetEmailTemplates';
import { createAsyncReducer } from 'utils/Redux';

import { getEmailTemplatesActions } from '../actions';

export default createAsyncReducer<GetEmailTemplatesMeta, GetEmailTemplatesPayload>(getEmailTemplatesActions);
